<template>
  <div v-if="infoStripe && infoStripe.externalId && isOpen" class="info-stripe">
    <button class="close" v-on:click="close"></button>
    <h4 class="title">
      {{ infoStripe.title[userLanguage] || infoStripe.title[fallBackLocale] }}
    </h4>
    <p class="message">
      {{ infoStripe.message[userLanguage] || infoStripe.message[fallBackLocale] }}
    </p>
  </div>
</template>

<script lang="ts">
import { useLocale } from '@/composables/locale';
import { InfoStripeModel } from '@/models/info-stripe.model';
import { InfoStripeService } from '@/services/info-stripe.service';
import { useUserStore } from '@/stores/user';
import { defineComponent } from 'vue';
import { globalConstants } from '../../constants/global.constants';

export default defineComponent({
  name: 'info-stripe',
  setup() {
    const { selectedAccount } = useUserStore();
    const { userLanguage } = useLocale();

    return { selectedAccount, userLanguage, fallBackLocale: globalConstants.fallBackLocale };
  },
  data() {
    return {
      infoStripeService: new InfoStripeService(),
      infoStripe: new InfoStripeModel(),
      isOpen: false,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      if (this.selectedAccount.countryId && !sessionStorage.getItem('hideInfoStripe')) {
        this.fetchInfoStripe(this.selectedAccount.countryId);
      }
    },
    async fetchInfoStripe(countryId: string) {
      const validation = await this.infoStripeService.getInfoStripes(countryId);

      if (validation.model) {
        this.infoStripe = validation.model[0];
        this.isOpen = true;
      }
    },
    close() {
      this.isOpen = false;
      sessionStorage.setItem('hideInfoStripe', 'true');
    },
  },
});
</script>
<style scoped lang="scss">
.info-stripe {
  @include breakpoint(small) {
    padding: 35px 10px 20px;
  }

  position: relative;
  padding: 20px 80px;
  background-color: var(--pale-pinkish-color);
  color: var(--primary-text-color);

  .title,
  .message {
    margin: 0;
  }

  .title {
    margin-bottom: 5px;
    font-weight: 400;
  }

  .close {
    @include breakpoint(small) {
      top: 0;
      right: 0;
    }

    &:after,
    &:before {
      background-color: var(--primary-dark-color);
    }
  }
}
</style>
